<template>
	<AsiCardDetail :title="$t('item.replaceItem')" :icon="icons.clone"
	               :show-action-button="!readonly" :action-button-disabled="disabled" @actionButtonClicked="updateDialog.open()">
		<AsiCardDetailEntry  :label="$t('item.terms.itemReplacedBy')">
			<template v-slot:avatar v-if="item.replacedBy" >
				<AsiAvatar :icon="icons.item" :image-url="itemAvatarUrl" :size="32"/>
			</template>
			<template v-slot>
				<router-link v-if="detailRoute !== null" :to="detailRoute" :title="nameTranslated"
				             @click.native.stop
				             style="text-decoration: inherit; color: inherit;">
					{{ item.replacedBy?.itemNumber }}
				</router-link>
			</template>
		</AsiCardDetailEntry>

		<ItemUpdateDialogReplacedBy v-if="!readonly && updateDialog.isLoaded" :open="updateDialog.isOpen" :item="item"
		                       @cancel="updateDialog.close()" @save="updateDialog.close(); change();"/>
	</AsiCardDetail>
</template>

<script lang="ts">
	import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
	import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
	import ItemStateChip from "@/components/item/ItemStateChip.vue";
	import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
	import ItemUpdateDialogState from "@/components/item/admin/ItemUpdateDialogState.vue";
	import ItemUpdateDialogReplacedBy from "@/components/item/admin/ItemUpdateDialogReplacedBy.vue";
	import {IItemAdmin, IItemAdminSimple} from "@/models/item/ItemAdminModels";
	import Icon from "@/plugins/icons";
	import DialogHandler from "@/components/common/DialogHandler";
	import AsiAvatar from "@/components/common/AsiAvatar.vue";
	import ItemHelper from "@/models/item/ItemHelper";
	import {AttachmentMediaSize, ItemType} from "@/helpers/constants";
	import TranslatedValueHelper from "@/models/translated-value/TranslatedValueHelper";
	import {RawLocation} from "vue-router";

	@Component({
		components: {
			AsiAvatar,
			ItemUpdateDialogReplacedBy, ItemUpdateDialogState, AsiCardDetail, ItemStateChip, AsiCardDetailEntry}
	})
	export default class ItemCardReplacedBy extends Vue {

		@Prop({type: Object, required: true})
		public item!: IItemAdmin;

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		@Prop({type: Boolean, default: false})
		public disabled!: boolean;

		private icons = Icon;
		private updateDialog: DialogHandler = new DialogHandler();

		private itemName(item: IItemAdminSimple): string {
			return TranslatedValueHelper.get(item.name, this.$i18n.locale, true) ?? '?';
		}

		private get label(){
			return this.item.replacedBy != null ? this.itemName(this.item.replacedBy) : this.$t('item.terms.itemNotReplaced');
		}

		private get value(){
			return this.item.replacedBy != null ? this.item.replacedBy.itemNumber : null;
		}

		private get itemAvatarUrl(): string | null {
			if (this.item.replacedBy == null) return null;
			return ItemHelper.avatarUrl(this.item.replacedBy, AttachmentMediaSize.s);
		}

		private get detailRoute(): RawLocation | null {
			if (this.item.replacedBy == null || this.item.replacedBy.itemType !== ItemType.shopItem) return null;
			return ItemHelper.detailRouteAdmin(this.item.replacedBy.id);
		}

		private get nameTranslated(): string | null {
			if (this.item.replacedBy == null) return null;
			return TranslatedValueHelper.get(this.item.replacedBy.name, this.$i18n.locale);
		}

		@Emit('change')
		public change(): void {
			return;
		}
	}
</script>



<style scoped lang="scss">

</style>
